// 사업자 정보 단일 출처(전자상거래 표시의무 + 푸터/약관/방침에서 재사용).
// PG/카드사 심사 요건: 사업자 정보가 사이트에 명시돼야 한다.
// 값 변경 시 이 파일만 고치면 푸터/사업자정보 페이지/약관/개인정보처리방침에 일괄 반영된다.

export const BUSINESS_INFO = {
  // 상호 및 대표자.
  name: "열린축산",
  ceo: "이정권",
  // 사업자등록번호.
  bizRegNo: "582-64-00372",
  // 사업장 주소.
  address: "인천광역시 서구 서로4로 89, 상가동 118호(원당동, 예미지트리플에듀)",
  // 고객문의 유선번호 / 이메일.
  tel: "032-568-2919",
  email: "b.shop2919@gmail.com",
  // 통신판매업 신고번호. 신고 완료 후 값 입력하며, 값이 없으면 화면에 항목 자체를 노출하지 않는다.
  ecommerceRegNo: null as string | null,
  // 개인정보 보호책임자.
  privacyOfficer: {
    name: "이정권",
    contact: "032-568-2919 / b.shop2919@gmail.com",
  },
} as const;
